module.exports = __webpack_public_path__ + "media/images/views/lp/home/client-logo/dda-fb6e69b153a2eab5995fcad2f57c5894.jpg";